import { Component } from '@angular/core';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { ORGANIZATION_SEARCH_CRITERIA_KEY, OrganizationSearchCriteria } from '../../../models/searchCriteria/OrganizationSearchCriteria';
import { Organization } from '../../../models/Organization';
import { CommonModule } from '@angular/common';
import { AppConstants } from '../../../utils/AppConstants';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrganizationService } from '../../../services/organization.service';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { AlertService } from '../../shared/alert/alert.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-organization-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ConfirmAlertComponent,
    HasPermissionDirective,
    FilterPanelComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective,
  ],
  templateUrl: './organization-list.component.html',
  styleUrl: './organization-list.component.scss',
})
export class OrganizationListComponent {
  searchForm!: FormGroup;
  emptySearchCriteria: OrganizationSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: OrganizationSearchCriteria = { ...this.emptySearchCriteria };

  organizations: Organization[] = [];

  selectedOrganization?: Organization;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private organizationService: OrganizationService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);
  }

  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(ORGANIZATION_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, ORGANIZATION_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  edit(organizationId: number) {
    this.router.navigate(['organizations/' + organizationId]);
  }

  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, ORGANIZATION_SEARCH_CRITERIA_KEY);
    this.organizationService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.organizations = res.items;
        this.totalItems = res.totalItems;
      },
      complete: () => {
        this.fullSpinnerService.spinner(undefined);
      },
      error: () => {
        this.fullSpinnerService.spinner(undefined);
      },
    });
  }

 search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }

  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as OrganizationSearchCriteria;
    this.find();
  }

  confirmOperation(
    organitation: Organization,
    confirmOperationType: 'DEL' | undefined
  ) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage =
        "Eliminazione ente - Sicuro di voler eliminare l'ente " +
        organitation.name;
    }
    this.selectedOrganization = organitation;
  }

  cancelModalOperationExec() {
    this.selectedOrganization = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.organizationService
        .delete(this.selectedOrganization!.id!)
        .subscribe({
          next: (res) => {
            this.alertService.addErrors(
              AppConstants.titleDeleteSuccessMessage,
              [AppConstants.successMessage],
              true
            );
            this.cancelModalOperationExec();
            this.fullSpinnerService.spinner(undefined);
            this.find();
          },
          complete: () => { },
          error: () => {
            this.cancelModalOperationExec();
            this.alertService.addErrors(
              AppConstants.titleErrorMessage,
              [AppConstants.errorMessage],
              true
            );
            this.fullSpinnerService.spinner(undefined);
          },
        });
    }
  }
}
